import { CalendarEvent } from 'owa-calendar-types';
import { isPreviewItemId } from 'owa-quick-compose-controller';
import {
    CalendarSurfaceItemsConfig,
    CalendarSurfaceStore,
    createDragHelperDecorator,
    createItemsDecorator,
    isOverflowIndicatorId,
    overflowItemTemplate,
    SurfaceEventHandlers,
} from 'owa-calendar-surface-dategrid';
import { isDragItemId } from 'owa-calendar-surface-dategrid-common-dnd';
import { dayGridBlankItemTemplate, getDayGridStandardItemTemplate } from './DayGridTemplates';
import type { ColorScheme } from 'owa-color-utils/lib/ColorScheme';

export const getDayGridItemConfig = (
    viewState: CalendarSurfaceStore,
    itemEventHandlers: SurfaceEventHandlers,
    overflowEventHandlers: SurfaceEventHandlers,
    generateColorScheme: (model: CalendarEvent) => ColorScheme,
    joinButtonVisible: boolean,
    shouldHideTooltip?: () => boolean,
    overrideIsSelectedDecorator?: (model: CalendarEvent) => boolean
): ((model: CalendarEvent) => CalendarSurfaceItemsConfig) => {
    return (model: CalendarEvent) => {
        if (isOverflowIndicatorId(model.ItemId.Id)) {
            return {
                itemsEventHandlers: overflowEventHandlers,
                itemsDecorator: createItemsDecorator(viewState),
                template: overflowItemTemplate,
            };
        }
        if (isPreviewItemId(model.ItemId.Id)) {
            return {
                itemsDecorator: createItemsDecorator(viewState),
                template: dayGridBlankItemTemplate,
            };
        }

        const standardItemTemplate = getDayGridStandardItemTemplate(
            generateColorScheme,
            joinButtonVisible,
            shouldHideTooltip
        );

        if (isDragItemId(model.ItemId.Id)) {
            return {
                itemsDecorator: createDragHelperDecorator(viewState),
                template: standardItemTemplate,
            };
        }

        return {
            itemsEventHandlers: itemEventHandlers,
            itemsDecorator: createItemsDecorator(viewState, overrideIsSelectedDecorator),
            template: standardItemTemplate,
        };
    };
};
